import React from 'react';
import { ProductCard } from './ProductCard';

/**
 * Kategorie-Sektion für die Sortiment-Seite
 * Zeigt Kategorie-Header und Produktraster
 */
export const CategorySection = ({ category, isFirstCategory = false }) => {
  return (
    <div id={category.id} className="mb-12 sm:mb-16 scroll-mt-32">
      {/* Category Header */}
      <div className="flex items-center gap-3 mb-6">
        <span className="text-3xl sm:text-4xl">{category.icon}</span>
        <div>
          <h2 className="text-2xl sm:text-3xl font-bold text-[#1e1919]">
            {category.title}
          </h2>
          {category.description && (
            <p className="text-[#736c64] text-sm sm:text-base">{category.description}</p>
          )}
        </div>
      </div>

      {/* Products Grid - max 3 per row */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-5">
        {category.products.map((product, idx) => (
          <ProductCard 
            key={idx} 
            product={product} 
            priority={isFirstCategory && idx < 3}
          />
        ))}
      </div>
    </div>
  );
};

export default CategorySection;
